import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_CAMPAIGN_SUMMARY',
    'FETCH_CAMPAIGN_SUMMARY_SUCCESS',
    'FETCH_ADGROUP_SUMMARY',
    'FETCH_ADGROUP_SUMMARY_SUCCESS',
    'FETCH_CREATIVE_SUMMARY',
    'FETCH_CREATIVE_SUMMARY_SUCCESS',
    'RESET_TO_INITIAL_STATE'
], 'YOUTUBE');


// Action Creators
export const fetchYouTubeCampaignSummary = createAction(actions.FETCH_CAMPAIGN_SUMMARY, params => params);
export const youtubeCampaignSummaryFetched = createAction(actions.FETCH_CAMPAIGN_SUMMARY_SUCCESS, data => data);
export const fetchYouTubeAdgroupSummary = createAction(actions.FETCH_ADGROUP_SUMMARY, params => params);
export const youtubeAdgroupSummaryFetched = createAction(actions.FETCH_ADGROUP_SUMMARY_SUCCESS, data => data);
export const fetchYouTubeCreativeSummary = createAction(actions.FETCH_CREATIVE_SUMMARY, params => params);
export const youtubeCreativeSummaryFetched = createAction(actions.FETCH_CREATIVE_SUMMARY_SUCCESS, data => data);
export const resetYoutubeInitialState = createAction(actions.RESET_TO_INITIAL_STATE);

// Reducers
const initialSummaryState = {
    data: undefined,
    hasData: null
};

const initialState = {
    campaign: {
        summary: initialSummaryState
    },
    adgroup: {
        summary: initialSummaryState
    },
    creative: {
        summary: initialSummaryState
    }
};

export default handleActions({

    [actions.FETCH_CAMPAIGN_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                campaign: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            campaign: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ADGROUP_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                adgroup: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            adgroup: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_CREATIVE_SUMMARY_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const updatedData = {
                creative: {
                    summary: {
                        data: { $set: action.payload.data },
                        hasData: { $set: hasData }
                    }
                }
            };
            return update(state, updatedData);
        }

        const updatedData = {
            creative: {
                summary: {
                    hasData: { $set: hasData }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })

}, initialState);



// WEBPACK FOOTER //
// ./src/services/youtube/duck.js